import { useLayoutEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

/** Reads an emailed link's query once; a layout effect drops it from the URL before any tracker or request sees it. */
export function useLinkParams(): URLSearchParams {
  const { search } = useLocation();
  const [params] = useState(() => new URLSearchParams(search));

  useLayoutEffect(() => {
    if (!window.location.search) return;
    // Keeps the router's history state, so Back and Forward still work.
    window.history.replaceState(window.history.state, '', `${window.location.pathname}${window.location.hash}`);
  }, []);

  return params;
}
